module.exports = __webpack_public_path__ + "img/177a1f777ab51378f2621b04d5b310b2.png";